import {
  Breakpoint,
  BreakpointListener,
  Breakpoints,
  Option,
  RadioGroup,
} from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import React, { ReactElement, useMemo, useState } from 'react';
import { Message, useMessage, useMessageGetter } from '@messageformat/react';
import CourseTaskHeader from '../CourseTaskHeader';
import { ReactComponent as Image013 } from '../../images/OP_symbolikuvitus_128_013.svg';
import parseMsgContent from '../../util/parseMsgContent';
import CourseContent from '../CourseContent';
import TaskTwoTiles from './TaskTwoTiles';

type Content = {
  columns: number;
};

const TaskTwo = (): ReactElement => {
  const [selectedValue, setSelectedValue] = React.useState('');
  const [breakpoint, setBreakpoint] = useState<Breakpoint | null>(null);
  const [showQuestionTwoResult, setShowQuestionTwoResult] = useState(false);
  const questionTwoArray = useMessage('course5.task2.answer_options');
  const getAnswerTwo = useMessageGetter('course5.task2.courseContent');
  const taskIntro = useMessage('course5.task2.intro');
  const parsedTask = parseMsgContent(taskIntro);

  const content = breakpoint?.content ? (breakpoint.content as Content) : null;

  const breakpoints: Breakpoints = useMemo(() => {
    return [
      { from: 0, to: 767, content: { columns: 1 } },
      {
        from: 768,
        to: Number.MAX_SAFE_INTEGER,
        content: { columns: 1 },
      },
    ];
  }, []);

  return (
    <BreakpointListener breakpoints={breakpoints} onChange={setBreakpoint}>
      <div style={{ paddingTop: space.xxl }}>
        <CourseTaskHeader questionNumber={2} totalQuestions={2} />
        <div style={{ marginTop: space.large, marginBottom: space.default }}>
          <CourseContent content={parsedTask} />
        </div>
        <RadioGroup
          columns={content?.columns}
          buttons
          onChange={(_ev, value) => {
            setShowQuestionTwoResult(true);
            setSelectedValue(value);
          }}
          value={selectedValue}
        >
          {Object.keys(questionTwoArray).map((value) => {
            return (
              <Option
                data-testid={`course5-task2-radio-${value}`}
                key={value}
                value={value}
                labelProps={{
                  style: { padding: '20px', alignItems: 'center', border: 0 },
                  className: 'investoracademy-radio-group-option',
                }}
              >
                <div style={{ flexDirection: 'column' }}>
                  <p className="opds-styles-v1-text-body-xl investoracademy-radiotile-title">
                    {value && (
                      <Message id={`${'course5.task2.answer_options'}.${value}.title`} />
                    )}
                  </p>
                  <p className="opds-styles-v1-text-body-xs investoracademy-radiotile-body">
                    {value && (
                      <Message id={`${'course5.task2.answer_options'}.${value}.body`} />
                    )}
                  </p>
                </div>
              </Option>
            );
          })}
        </RadioGroup>
      </div>
      <div
        style={{
          display: showQuestionTwoResult ? 'block' : 'none',
          marginBottom: space.large,
        }}
      >
        <Image013
          className="investoracademy-small-svg"
          style={{
            marginTop: space.xxl,
          }}
          aria-hidden="true"
        />
        <div
          className="opds-styles-v1-text-title-small-strong"
          style={{
            textAlign: 'center',
            color: '#EE5A00',
            paddingTop: space.xs,
            paddingBottom: 0,
            marginBottom: `-${space.large}`,
          }}
        >
          <Message id="choice" />
        </div>
        {showQuestionTwoResult && (
          <>
            <CourseContent
              content={parseMsgContent(getAnswerTwo(`content${selectedValue}`))}
              headingAs="h4"
            />
            <TaskTwoTiles answerNumber={selectedValue} />
          </>
        )}
      </div>
    </BreakpointListener>
  );
};

export default TaskTwo;
